export type StoredAssignedFarmsFilters = {
  q?: string
  program?: string
  hub?: string
  status?: 'signed' | 'terminating' | 'terminated'
  sort?: 'name:desc' | 'program:asc' | 'program:desc' | 'hub:asc' | 'hub:desc'
}

const STORAGE_KEY = 'assignedFarmsFilters'

// sessionStorage on purpose (card 5576): survives refresh and in-tab navigation, but a new
// session or another user in a new tab never inherits stale hub filters.
export const readStoredAssignedFarmsFilters = (): StoredAssignedFarmsFilters | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as StoredAssignedFarmsFilters) : null
  } catch {
    return null
  }
}

export const writeStoredAssignedFarmsFilters = (filters: StoredAssignedFarmsFilters): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filters))
  } catch {
    // no-op: session-only convenience, never worth breaking the filters over
  }
}

export const clearStoredAssignedFarmsFilters = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // no-op
  }
}
